/* Fransk katalog for locale-autopilot-followup.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'ap.skip.title': 'Ignorer le suivi',
  'ap.skip.nextMonth': 'Me le rappeler le mois prochain',
  'ap.skip.always': 'Ignorer ce point',
  'ap.skip.help': 'Reportez le point au mois prochain ou ignorez uniquement ce point. Les nouvelles factures, les nouveaux clients et les autres nouveaux constats continueront de s\'afficher.',
  'ap.skip.itemFallback': 'Ce point de suivi',
  'ap.skip.all': 'Tout ignorer',
  'ap.skip.allInvoices': 'Tous les documents de cette liste',
  'ap.skip.allCustomers': 'Tous les clients de cette liste',
  'ap.agent.followup.title': 'Agent de suivi',
  'ap.agent.followup.detail': 'Détecte les informations et les écarts qui ne relèvent d\'aucun agent de déclaration.',
  'ap.permission.followup.label': 'Agent de suivi',
  'ap.permission.followup.desc': 'Détecte les informations, les échanges avec les clients et les écarts qui ne relèvent d\'aucun agent de déclaration.',
  'ap.lineIgnoredToast': 'Ce point est ignoré. Les nouveaux points de suivi continueront de s\'afficher.',
  'ap.linesSkippedToast': '{{count}} points ont été ignorés.',
  'ap.followup.correctionOne': '{{count}} erreur doit être corrigée.',
  'ap.followup.correctionMany': '{{count}} erreurs doivent être corrigées.',
  'ap.followup.correctionDetailOne': '{{count}} point doit être corrigé',
  'ap.followup.correctionDetailMany': '{{count}} points doivent être corrigés',
  'ap.followup.mustCorrect': 'À corriger',
  'ap.followup.correct': 'Corriger',
  'ap.followup.correctInSettings': 'Corriger dans les paramètres',
});
